module.exports = __webpack_public_path__ + "static/media/sb_tip5.654464a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/sb_tip5.jpg
// module id = 546
// module chunks = 0